import Head from "next/head";
import EmailSignupBanner from "../../../components/EmailSignupBanner";
import Layout from "../../../components/Layout";
import { Button, Group, Modal, Space, Stack, Text, TextInput, Title} from '@mantine/core'
import { MenuId } from "../../../components/Header";
import styles from './vote.module.scss'


import { GetServerSideProps } from "next";
import { getGalleryImages, voteForImage } from "../../../lib/data";
import { RusAuthProps, RusContextProps, UserImage, ImageData } from "../../../lib/definitions";

import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { modals } from '@mantine/modals';

import { useWindowEvent } from '@mantine/hooks';
import imgAandI from './images/a-and-i.png';
import imgCass from './images/cass_art_logo_1984_black-01.jpg';
import Image from 'next/image';

import Masonry from "react-responsive-masonry";
import { AspectBox } from "../../../components/AspectBox";
import Cookies from 'universal-cookie';
import { okModalEx } from "../../../lib/utils";
import axios from 'axios';
import Link from "next/link";
import { logSubscribeToNewsletter, setBrowserEmail } from "../../../lib/logger";
import { useForm } from "@mantine/form";
import { Price } from "../../../components/Localization";

const DEFAULT_NGG_ID = 77;

const artistRegEx= /'(.*)' by (.*)/;
const cookieName='ip-24';

const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
  
  type ImageDataEx = ImageData & {artist?:string, description?:string, title?:string};

  type Data = {
    images : ImageDataEx [],
    votingClosed: boolean,
    resultsAnnounced: boolean
  
  
    }

    
type formValues =
{
  email:string;
}


function EmailCapture()
{

  //have to define this as a separate component to prevent odd bugs

  const form = useForm<formValues>({
    initialValues: {
      email: '',
    }
});

let [submitting, setSubmitting] = useState(false);
 

async function submitHandler(data : formValues)
{

  setSubmitting(true);
  await fetch('/n/api/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    credentials:"include"
  });
  logSubscribeToNewsletter();
  await setBrowserEmail(data.email);

  setSubmitting(false);
  modals.closeAll();

}


return <>
<form onSubmit={form.onSubmit(async (values) => await submitHandler(values))}>
<Stack>

<Text>Would you like to subscribe to our mailing list?</Text>
<Text>We&rsquo;ll keep you informed about upcoming online sessions, workshops and events. Plus we’ll give you access to <b>SEVEN</b> of our previous sessions, all for <b>FREE</b>, and a voucher worth <Price gbp={5}/> for a future livestream</Text>


  <TextInput
    width={300}
    type='email'
    required
    label="Email"
    placeholder="hello@example.com"
    value={form.values.email}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => form.setFieldValue('email', event.currentTarget.value)}
    error={form.errors.email && 'Invalid email'}
  />
    <Group position="center">
          <Button disabled={submitting} type="submit">Yes please! Subscribe me.</Button>
<Button variant = 'outline' disabled={submitting} onClick={() => modals.closeAll()}>No thank you</Button>

</Group>
</Stack>


<div className={styles.privacyPolicy}>
We won&rsquo;t sell or share your data and you can unsubscribe at any time. You can see our privacy policy <Link href='/privacy-policy'>here</Link>
</div>
</form>
</>

}

export default function UserImages({data} : {data: Data & RusAuthProps & RusContextProps})
{
  let [lightboxImage, setLightboxImage] = useState<ImageDataEx | null>(null);
  let [showLightBoxFlag, setShowLightBoxFlag] = useState(false);
  let [images, setImages] = useState(data.images);

  let [imageWidth, setImageWidth] = useState(540);
  let [imageHeight, setImageHeight] = useState(540);

  let [voted, setVoted] = useState(false);

  const firstRender = useRef(true);
  const cookies = new Cookies();

  function resizeImage()
  {
    if (lightboxImage)
    {
      let maxWidth = Math.max(window.innerWidth - 50,200);
      let maxHeight = Math.max(window.innerHeight - 125, 200);
      let width = maxWidth;
      let height = width * lightboxImage.height/lightboxImage.width;

      if (height>maxHeight)
      {
        height = maxHeight;
        width = height * lightboxImage.width / lightboxImage.height;
      }

      setImageWidth(width);
      setImageHeight(height);
      
    }
  }
  useIsomorphicLayoutEffect(()=>
  {
    resizeImage();
  }
  ,[lightboxImage]);

 

  useWindowEvent("resize", ()=>{resizeImage()});

  useEffect(()=>
  {

    /*
    async function retrievePoll()
      {
          let a = await axios.get(`${process.env.NEXT_PUBLIC_ELTON_ROUTE}/polls/${props.id}`);
          setPoll(a.data);
      }

      retrievePoll();*/
  
      if (cookies.get(cookieName)=='true')
      {
        setVoted(true);
      }

  }, []);

     

  function showLightBox(image: ImageDataEx)
  {
    setLightboxImage(image);
    setShowLightBoxFlag(true);
  }

  function closeLightbox()
  {
    setShowLightBoxFlag(false);
  }

  async function vote(x: ImageDataEx)
  {
    
    //no need to await or track errors
     axios.post('/n/api/image-vote',
    JSON.stringify({id: x.id, contest:'ip-2024'}),
    {
      headers:{'Content-Type': 'application/json'},
      withCredentials: true             
  });

    cookies.set(cookieName,"true", {expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 800),  sameSite: "lax", path:"/"});
    setVoted(true);

    //okModalEx("Thank you!", `Thank you for voting for ${x.altText}!`);

    modals.open({
      title: <><b>Thank you for voting!</b></>,
      withCloseButton:true,
      closeOnClickOutside:true,

    
      children:
      (
        <div className={styles.container}>
          <EmailCapture/>
        </div>
      )
    })
}
  
  let url = `/n/api/thumbnails/${lightboxImage?.id}?w=1080&t=${lightboxImage?.updatedAt}`

    return(
        <>
        <Modal opened={showLightBoxFlag} onClose={closeLightbox} fullScreen closeOnEscape={false}>


      <div style={{display:"flex", width:"100%", height:"100%", justifyContent:"center"}}>
      <div className={styles.lightboxBorder} style={{width:imageWidth, height:imageHeight}}>
        {lightboxImage && <div style={{ width:"100%", height:"100%", backgroundImage:`url('${url}')`, backgroundSize:"contain", backgroundPosition:"center", backgroundRepeat:"no-repeat"}}></div>}
        </div>
     
        </div>
        <div style={{textAlign:'center', marginTop:10}}>
            <Button onClick={closeLightbox}>Close</Button>
            {(!voted && !data.votingClosed) && <Button ml='md' onClick={()=>vote(lightboxImage!)}>Vote for me!</Button>}
            </div>
        
        </Modal>
      
        <Layout menuId={MenuId.online} hidePopUp={true}>

  
  <Head>
      <title>Vote for your favourite entry from our Image Reference Prize</title>
      <meta name="description" content="Your chance to choose your favourite entry from the Raw Umber Studios Image Prize"/>      
  </Head>
  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>Vote for your favourite entry from our Image Reference Prize</h1>
    <Text>To celebrate our <Link href='/image-search'>online image reference library</Link>, we offered a cash prize of £1000 and a feature in Artists & Illustrators Magazine for the best drawing or painting based on one of our image references. The quality of entries was so high that as well as <Link href='/winner-of-raw-umber-image-prize-2024-announced'>the overall winner</Link>, we&rsquo;ve decided to award an <b>additional</b> prize of £500 and £250 of Cass Art vouchers (thank you <a href="https://cassart.co.uk" target="_blank">Cass Art</a> for this very generous donation)*, chosen by you, the public.</Text>
    <Text mt='md'>It was extremely hard to choose both the winner and this shortlist. We&rsquo;ve selected them based on a combination of different factors, including technical skill and emotional power. We&rsquo;ve also tried to include a diversity of styles, media and models.</Text>
    <Text mt='md'>Thank you very much to everybody who entered, and congratulations to our <Link href='/winner-of-raw-umber-image-prize-2024-announced'>winner</Link> and finalists!</Text>

      {data.votingClosed?
      <Text  mt='md'>Voting has now closed. You can see the results <Link href='/winner-of-raw-umber-image-prize-2024-public-choice-award-announced'>here</Link>  </Text>:
      (
    voted?
    <Text mt='md'>Thank you for voting!{data.resultsAnnounced ? <>You can see the results <Link href='/winner-of-raw-umber-image-prize-2024-public-choice-award-announced'>here</Link></>:<>Voting closes on 16th February 2025. We&rsquo;ll announce the rsults shortly after.</>}</Text>
    :
    <Text mt='md'>We&rsquo;ve chosen fifteen of our favourite entrants. To vote, simply click on the image you like the most and tap the vote button. Voting closes on 16th February 2025 at 12 noon GMT</Text>
    )}

    <Text color="grey" size='sm' mt='lg'>* Note that only UK residents are eligible for the Cass Art vouchers. If a non-UK resident wins the public choice award, then we will choose another entrant to receive the vouchers</Text>
  </div>
  
  <Space h='lg'/>
  
<div style={{maxWidth:1000, marginLeft:"auto", marginRight:"auto", position:"relative"}}>



<Masonry columnsCount={2}>
{images.map(x => (
                <Tile key={x.id} image={x} vote={vote} showLightBox={showLightBox} canVote={!voted && !data.votingClosed}/>))}
</Masonry>




           
<div>
<Title mt='lg' order={3} mb='sm' align="center">We&rsquo;d like to thank our supporters:</Title>

<div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'center'}}>
    <div className={styles.logo} style={{marginTop:16, marginBottom:32}}><a href='https://www.artistsandillustrators.co.uk/' target='_blank'><Image src={imgAandI} width={250} alt='Artists & Illustrators Logo'/></a></div>
    <div className={styles.logo} style={{marginLeft:32}}><a href='https://cassart.co.uk/' target='_blank'><Image src={imgCass} width={250} alt='Cass Art'/></a></div>

    </div>
    </div>
</div>
  <EmailSignupBanner/>
  </Layout>



        </>

    );
  }

  

  function Tile({image, showLightBox, vote, canVote} : {image:ImageDataEx, showLightBox: (x:ImageDataEx)=>void, vote: (x:ImageDataEx)=>void, canVote:boolean })
  {

    const [hover, setHover] = useState(false);

  async function mouseEnter(e: React.MouseEvent)
  {
    setHover(true);
  }

  async function mouseLeave(e: React.MouseEvent)
  {
    setHover(false);
  }


    let url = '';

    return <div onClick ={mouseEnter} onMouseEnter = {mouseEnter} onMouseLeave={mouseLeave} style={{margin:5}}>
       
        <AspectBox width= {image.width} height ={image.height} >
    <div style={{position:'relative', maxWidth:600}}>
        {/*eslint-disable-next-line @next/next/no-img-element*/}
        <img style = {{borderRadius:5}} alt = {image.altText} src={`/n/api/thumbnails/${image.id}?w=600&t=${image.updatedAt}`} width="100%"/>
        {hover && 
        <>
        <div style={{ textAlign:"center", position:'absolute', bottom:0, width:'100%', marginBottom:0, background:'#fffa'}}>
            {image.artist&&<><div className={styles.imageFooter}><i>
                <a href='#' className={styles.hoverInline} onClick={ (e)=>{e.preventDefault(); showLightBox(image)}}>   
   {image.title}
   </a></i> by {image.artist}</div></>}
                <div className={styles.votingBox}>
   {canVote && <>
   <Button className={styles.responsiveButton}  onClick={async x=> await vote(image)}>Vote for me!</Button>
   
   </>}
   </div>
            </div>
            </>}
 
    </div>
   
  
    </AspectBox>
    </div>
   
  }

          

export const getServerSideProps : GetServerSideProps = async (context)=>
{

  let closed=true;
  let winnersAnnounced = false;

  let competitionStatus : string = '' + process.env.IMAGE_COMPETITION_STATUS;

  if (competitionStatus!='PUBLIC-VOTING' && competitionStatus!='CLOSED' && competitionStatus!='ALL-DONE')
    {
      return { notFound: true };
    }

    if (competitionStatus=='PUBLIC-VOTING')
      {
        closed =false;
      }

  
  var galleryId = DEFAULT_NGG_ID;

    if (process.env.IMAGE_PRIZE_2024_NGG_ID)
    {
      galleryId=parseInt(process.env.IMAGE_PRIZE_2024_NGG_ID);
    }
    
    let images=await getGalleryImages(galleryId);

    let imagesEx: ImageDataEx[] = images.map(
        (x)=>{        
            let i2 = artistRegEx.exec('' + x.altText);
            let artist='';
            let title='';

            if (i2)
            {
                artist = i2[2];
                title = i2[1];
            }

            let y :ImageDataEx = { description : x.description, artist:artist, title:title, ...x}
            return y;
        });


    return {
      props: {
        data: 
        { 
          votingClosed: closed,
          resultsAnnounced: (competitionStatus=='ALL-DONE'),
            images:imagesEx
        }
     }   

    }
}
